import { motion } from 'framer-motion';
import Button from '@mui/material/Button';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useNavigate } from 'react-router-dom';

const WhatWeDo = (props) => {
    const navigate = useNavigate();
    const listAccordions = [
        {
            title: "Entrega de obrigações fiscais", desc: (
                <>
                    Cumprir suas obrigações fiscais de forma <b>precisa e pontual</b> é essencial para <b>proteger seu patrimônio</b> e manter sua clínica em <b>conformidade</b>. Nós cuidamos disso por você, com <b>rigor técnico e tranquilidade</b>.
                </>
            )
        },
        {
            title: "Folha de pagamento e pró-labore", desc: (
                <>
                    Gestão completa da folha de pagamento e do pró-labore, <b>garantindo cálculos corretos, segurança jurídica e a tranquilidade</b> de que sua equipe está sempre valorizada.
                </>
            )
        },
        {
            title: "Consultoria e emissão de parecer contábil", desc: (
                <>
                    Mais do que números, oferecemos <b>clareza estratégica</b>. Nossos pareceres contábeis são elaborados com <b>profundidade técnica</b> e traduzidos em linguagem simples, para que você <b>tenha decisões seguras em mãos</b>.
                </>
            )
        },
        {
            title: "Abertura e regularização de clínicas e consultórios", desc: (
                <>
                    Transformamos a complexidade burocrática em um processo fluido. Da abertura ao pleno funcionamento, sua clínica ou consultório nasce <b>regularizado, sólido e pronto para crescer</b>.
                </>
            )
        },
        {
            title: "Emissão de Notas Fiscais de serviços de saúde", desc: (
                <>
                    <b>Agilidade e precisão na emissão das suas notas fiscais</b>. Tudo de acordo com a legislação, sem fricções, para que você mantenha sua prática profissional organizada e confiável.
                </>
            )
        },
        { title: "Atendimento especializado e humanizado", desc: "Cada profissional de saúde tem uma história única. Nosso atendimento respeita essa singularidade, unindo escuta ativa, proximidade e soluções contábeis feitas sob medida." },
    ];

    return (
        <>
            {/* SECTION 1 */}
            <section style={{ width: "100%", padding: "60px 0", display: "flex", justifyContent: "center", flexWrap: "wrap", backgroundColor: "#f9f2e4" }}>
                <div className="what-we-do-container" style={{ width: "80%", maxWidth: "1400px", display: "flex", justifyContent: "space-between", flexWrap: "wrap" }}>

                    {/* Lado Esquerdo */}
                    <motion.div
                        className="what-we-do-left"
                        initial={{ opacity: 0, x: -50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                        viewport={{ once: true }}
                        style={{
                            width: "48%",
                            minWidth: "300px",
                            padding: "20px 30px",
                            display: "flex",
                            flexDirection: "column",
                            justifyContent: "center",
                            alignItems: "flex-start",
                        }}
                    >
                        <div style={{ display: "flex", flexDirection: "column", gap: "20px" }}>
                            <div>
                                <p style={{ color: "#0b243d", fontWeight: "bold" }}>O QUE FAZEMOS</p>
                                <h1 style={{ fontSize: "clamp(1.6rem, 2.4vw, 2.4rem)", lineHeight: "1.3", marginBottom: "10px", color: "#0b243d" }}>
                                    Cuidamos da parte fiscal para que você foque no cuidado das pessoas.
                                </h1>
                            </div>
                            <p style={{ fontSize: "clamp(0.9rem, 1vw, 1rem)", marginBottom: "10px", color: "#222" }}>
                                Contabilidade simples, experiente e personalizada, <b>profissionalizamos</b> sua atividade, consultório ou clínica de forma <b>100% online e sem burocracias.</b>
                            </p>
                            <Button variant="contained" sx={{
                                padding: "14px 28px",
                                fontSize: "1rem",
                                backgroundColor: "#ffc845",
                                color: "#0b243d",
                                fontWeight: "bold",
                                borderRadius: "10px",
                                boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#e6b63d",
                                    transform: "scale(1.05)",
                                },
                            }}
                                onClick={() => navigate("../Solucoes")}
                            >
                                Contrate
                            </Button>
                        </div>
                    </motion.div>

                    {/* Lado Direito (Accordions) */}
                    <div
                        className="what-we-do-right"
                        style={{
                            width: "50%",            // ocupa toda a largura disponível
                            // maxWidth: "600px",        // limite em telas grandes
                            padding: "20px 0",
                            margin: "0 auto",         // centraliza no desktop
                        }}
                    >
                        {listAccordions.map((obj, i) => (
                            <motion.div
                                key={i}
                                initial={{ opacity: 0, y: 20 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.5, delay: i * 0.1 }}
                                viewport={{ once: true }}
                            >
                                <Accordion sx={{
                                    marginBottom: "20px",
                                    backgroundColor: "#fff",
                                    '& .MuiAccordionSummary-root': { backgroundColor: "#f9f2e4" },
                                    '& .MuiTypography-root': { color: "#0b243d", fontWeight: "600" }
                                }}>
                                    <AccordionSummary expandIcon={<ExpandMoreIcon sx={{ color: "#0b243d" }} />} aria-controls={`panel${i}-content`} id={`panel${i}-header`}>
                                        <Typography component="span">{obj.title}</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails sx={{ color: "#222" }}>
                                        {obj.desc}
                                    </AccordionDetails>
                                </Accordion>
                            </motion.div>
                        ))}
                    </div>
                </div>

                {/* Responsivo */}
                <style>{`
                    @media (max-width: 768px) {
                        .what-we-do-container {
                            flex-direction: column;
                            align-items: center;
                        }

                        .what-we-do-left, .what-we-do-right {
                            width: 100% !important;
                            padding: 20px 10px !important;
                        }

                        .what-we-do-left h1 {
                            font-size: 1.6rem !important;
                        }
                    }
                `}</style>
            </section>

            {/* SECTION 2 */}
            <section>
                <motion.div
                    initial={{ opacity: 0 }}
                    whileInView={{ opacity: 1 }}
                    transition={{ duration: 0.8 }}
                    viewport={{ once: true }}
                    style={{
                        width: "100%",
                        backgroundColor: "#0b243d",
                        color: "#fff",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        padding: "40px 0",
                    }}
                >
                    <div
                        className="container-bloco"
                        style={{
                            width: "90%",
                            maxWidth: "1400px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: "20px",
                            flexWrap: "wrap",
                        }}
                    >
                        {/* Imagem */}
                        <motion.div
                            className="imagem-bloco"
                            initial={{ opacity: 0, x: -50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            style={{
                                width: "30%",
                                minWidth: "200px",
                                display: "flex",
                                justifyContent: "center",
                            }}
                        >
                            <img
                                src="/assets/lora medica.jpeg"
                                alt="Profissional da saúde"
                                style={{
                                    width: "100%",
                                    maxWidth: "500px",
                                    objectFit: "contain",
                                    borderRadius: "8px",
                                    maskImage: "linear-gradient(to left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.3))",
                                    WebkitMaskImage: "linear-gradient(to left, rgba(0, 0, 0, 1), rgba(0, 0, 0, 0.3))",
                                }}
                            />
                        </motion.div>

                        {/* Texto + botão */}
                        <div
                            className="conteudo-bloco"
                            initial={{ opacity: 0, x: 50 }}
                            whileInView={{ opacity: 1, x: 0 }}
                            transition={{ duration: 0.8 }}
                            viewport={{ once: true }}
                            style={{
                                width: "65%",
                                minWidth: "250px",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "center",
                                alignItems: "center",
                                padding: "20px",
                                textAlign: "center",
                            }}
                        >
                            <h1
                                style={{
                                    fontSize: "clamp(1.2rem, 2.2vw, 2.2rem)",
                                    lineHeight: "1.4",
                                    marginBottom: "20px",
                                }}
                            >
                                Cuidamos da sua contabilidade para que você se concentre no que faz de melhor.
                            </h1>
                            {/* <Button
                                className='btn-plans'
                                onClick={() => props.scrollToPlans()}
                                variant="outlined"
                                sx={{
                                    padding: "14px 28px",
                                    fontSize: "1rem",
                                    color: "#ffc845",
                                    borderRadius: "10px",
                                    borderColor: "#ffc845",
                                    boxShadow: "0 4px 10px rgba(0,0,0,0.2)",
                                    transition: "0.3s ease",
                                    '&:hover': {
                                        backgroundColor: "#ffc845",
                                        color: "#0b243d",
                                        transform: "scale(1.05)",
                                    },
                                }}
                            >
                                ver os planos
                            </Button> */}
                        </div>
                    </div>

                    {/* Responsivo */}
                    <style>{`
                        @media (max-width: 768px) {
                            .container-bloco {
                                flex-direction: column !important;
                                align-items: center !important;
                                text-align: center;
                            }

                            .imagem-bloco, .conteudo-bloco {
                                width: 100% !important;
                            }

                            .imagem-bloco img {
                                display: none;
                            }

                            .btn-plans {
                                display: none;
                            }
                        }
                    `}</style>
                </motion.div>
            </section>
        </>
    );
};

export default WhatWeDo;
